/* src/app/timeline-transport/partals/timeline-transport-main-vertical/timeline-transport-main-vertical.component.scss */
.timelineBlock {
  width: 15rem;
  padding: 0.5rem;
  margin: 0.2rem;
  min-height: 2rem;
  background-color: #bdc3c7;
  display: inline-block;
  position: relative;
}
.timelineBlock.dragover {
  background-color: pink !important;
}
.timelineBlock .qty {
  background:
    #e51c23 linear-gradient(
      180deg,
      #e93e44,
      #e51c23) repeat-x;
  color: white;
  font-weight: bold;
  font-size: 0.7rem;
  position: absolute;
  right: 0;
  top: 0;
  min-width: 2.2rem;
  min-height: 1.5rem;
  text-align: center;
}
.timelineBlock .qty .qtyNo {
  text-align: center;
}
.timelineBlock.allocated {
  background-color: #636e72;
  color: white;
}
.timelineBlock.dragover {
  background-color: pink;
}
.smallBlock {
  width: 8rem;
}
.jobAllocationTable thead th {
  color: white;
}
.jobAllocationTable .time {
  border: 0;
  padding: 0.35rem;
  width: 8rem;
}
.jobAllocationTable td i {
  font-size: 1.3rem;
  color: white;
}
.jobAllocationTable td i:hover {
  color: #4caf50;
  cursor: pointer;
}
.blockContainer {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  width: 17rem;
}
.blockContainer.dragover {
  background-color: pink;
}
.allocationContainer {
  display: flex;
}
.roundHeader {
  background-color: white;
  color: white;
  border-top: 3px solid #27ae60;
  padding: 0.7rem;
  background: #34495e;
  min-width: 23rem;
}
.roundHeader.sub {
  background-color: #d35400;
  border-top: 3px solid #34495e;
}
.roundHeader button {
  padding: 0;
  width: 2.5rem;
  height: 1.5rem;
}
/*# sourceMappingURL=timeline-transport-main-vertical.component.css.map */
